// extracted by mini-css-extract-plugin
export default {"choiceButton":"answer_common_choiceButton__YAkyL","choices":"answer_common_choices__vJ4us"};